import React from 'react';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';

export type ConfirmDialogProps = {
    open: boolean;
    title: string;
    message: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    busy?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = false,
    busy = false,
    onConfirm,
    onCancel,
}) => {
    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
            onClick={e => { if (e.target === e.currentTarget && !busy) onCancel(); }}
        >
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md flex flex-col">
                <div className="flex items-start justify-between px-5 py-4 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                        <span className={`flex items-center justify-center w-9 h-9 rounded-full shrink-0
                            ${danger ? 'bg-red-100 text-red-600' : 'bg-gray-100 text-gray-600'}`}>
                            <FaExclamationTriangle size={15} />
                        </span>
                        <h2 className="text-base font-semibold text-gray-800 mt-1.5">{title}</h2>
                    </div>
                    <button
                        onClick={onCancel}
                        disabled={busy}
                        className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer p-1 disabled:opacity-50"
                    >
                        <FaTimes size={15} />
                    </button>
                </div>

                <div className="px-5 py-4 text-sm text-gray-600">
                    {message}
                </div>

                <div className="flex items-center justify-end gap-3 px-5 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl">
                    <button
                        onClick={onCancel}
                        disabled={busy}
                        className="px-4 py-2 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors disabled:opacity-50"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={busy}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-default
                            ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-800 hover:bg-gray-700'}`}
                    >
                        {busy ? 'Working…' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
